import Base64js from 'base64-js'
import { validate as uuidValidate } from 'uuid'
import moment from 'moment'
import { get } from 'lodash'

export function isBase64(str) {
  try {
    Base64js.toByteArray(str)
    return true
  } catch (err) {
    return false
  }
}

export function isUuid(str) {
  return uuidValidate(str)
}

export function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
// TODO: create other file for helper
export const processDateRangeForAPI = (dates, fieldName) => {
  const sortedCreatedAt = dates.sort((a, b) => new Date(a) - new Date(b))
  const dateAfter = get(sortedCreatedAt, '[0]')
  const dateBefore = get(sortedCreatedAt, '[1]')
  const formattedDateAfter = dateAfter
    ? moment(dateAfter).utc(true).startOf('day').format('YYYY-MM-DD HH:mm:ss')
    : null
  let formattedDateBefore
  if (get(sortedCreatedAt, '[1]')) {
    formattedDateBefore = dateBefore
      ? moment(dateBefore).utc(true).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      : null
  } else {
    formattedDateBefore = dateAfter
      ? moment(dateAfter).utc(true).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      : null
  }
  const afterKey = `${fieldName}[after]`
  const beforeKey = `${fieldName}[before]`
  return {
    [afterKey]: formattedDateAfter,
    [beforeKey]: formattedDateBefore
  }
}

export const getFilenameFromContentDisposition = (header) => {
  const dispositionRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/gi
  let matches
  let lastFilename

  while ((matches = dispositionRegex.exec(header)) !== null) {
    lastFilename = matches[1].replace(/['"]/g, '')
  }

  // Remove "utf-8''" prefix more flexibly
  lastFilename = lastFilename.replace(/(?:utf-8'')?(.*)/, '$1')

  // Decode URL-encoded characters
  lastFilename = decodeURIComponent(lastFilename)

  return lastFilename || null
}

export const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
